import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-statis",
  "use": "icon-statis-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-statis\"><path d=\"M917 872H107c-24.9 0-45 20.1-45 45s20.1 45 45 45h810c24.9 0 45-20.1 45-45s-20.1-45-45-45zM182 782c66.3 0 120-53.7 120-120V482c0-66.3-53.7-120-120-120S62 415.7 62 482v180c0 66.3 53.7 120 120 120z m-30-300c0-16.6 13.4-30 30-30s30 13.4 30 30v180c0 16.6-13.4 30-30 30s-30-13.4-30-30V482zM512 782c66.3 0 120-53.7 120-120V362c0-66.3-53.7-120-120-120s-120 53.7-120 120v300c0 66.3 53.7 120 120 120z m-30-420c0-16.6 13.4-30 30-30s30 13.4 30 30v300c0 16.6-13.4 30-30 30s-30-13.4-30-30V362zM842 62c-66.3 0-120 53.7-120 120v480c0 66.3 53.7 120 120 120s120-53.7 120-120V182c0-66.3-53.7-120-120-120z m30 600c0 16.6-13.4 30-30 30s-30-13.4-30-30V182c0-16.6 13.4-30 30-30s30 13.4 30 30v480z\" p-id=\"34595\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/statis.svg
// module id = Q57o
// module chunks = 250